import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const SimpleGuideLayer = Loadable({
    loader: () => import(/* webpackChunkName: "SimpleGuideLayer" */ './simpleGuideLayer'),
    loading: () => <div />,
});
